module.exports = __webpack_public_path__ + "static/media/midSwirl.6382c484.png";